// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerText_root__2X4m_"};